:host {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;

  jump-button, button{
    --jump-button-padding: 0.5rem;
  }

  [data-variant='horizontal'] {
    flex-direction: row;
  }

  label {
    color: var(--neutral-grey-secondary);
    font-size: 0.875rem;
  }

  input {
    //remove user agent styles
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    margin: 0;

    //remove + and - buttons
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    outline: none;

    &:focus {
      border-color: var(--secondary-standard);
    }

    border: 1px solid transparent;
    border-radius: 3px;
    padding: 0.5rem;
    height: 14px;
    width: 36px;
    font-size: 0.875rem;
    text-align: center;

    &:not([aria-hasbuttons]) {
      border-color: var(--neutral-grey-secondary);
    }

    &[type='button'] {
      cursor: pointer;
    }
  }

  ::slotted(jump-button) {
    --jump-button-padding: 0;
  }


  .jump-quantity__InnerWrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    gap: 0;
  }
}
